import axios from "@/lib/axios";
import { useQuery } from "@tanstack/vue-query";
import { Status } from "../interfaces/Status";

interface Props {
  immediate?: boolean;
}

const getStatusHotel = async (): Promise<Status[]> => {
  const { data } = await axios.get<Status[]>(`/api/internal/status/hotels`);
  return data;
};

const useStatusHotel = (props: Props) => {
  const { data, isLoading, refetch } = useQuery(
    ["status"],
    () => getStatusHotel(),
    {
      enabled: props.immediate,
    },
  );

  return {
    data,
    isLoading,
    refetch,
  };
};

export default useStatusHotel;
